import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Watermark } from '../ui';
import { newsletterService } from '../../services';

const EMAIL_RE = /\S+@\S+\.\S+/;

export default function AppNewsletter() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | invalid | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (!EMAIL_RE.test(email)) { setState('invalid'); return; }
    setState('sending');
    try { await newsletterService.subscribe(email); setState('done'); }
    catch { setState('error'); }
  };

  return (
    <div className="grid-2 app-news">
      <div className="app card">
        <div>
          <h3 className="app__title">{t('Ayodhya Dham App')}</h3>
          <p className="app__sub">{t('Download our app for easy bookings and live updates — coming soon to Android and iOS.')}</p>
          <div className="app__badges">
            <button type="button" className="store-badge" disabled title={t('Coming soon')}>
              <Icon name="smartphone" size={18} /><span><small>{t('Coming soon on')}</small>Google Play</span>
            </button>
            <button type="button" className="store-badge" disabled title={t('Coming soon')}>
              <Icon name="smartphone" size={18} /><span><small>{t('Coming soon on')}</small>App Store</span>
            </button>
          </div>
        </div>
        <div className="app__phone"><img src="/images/ram-lala/ram-lala-01.jpg" alt="" /></div>
      </div>

      <div className="newsletter card">
        <Watermark variant="temple" />
        <div className="newsletter__head">
          <span className="newsletter__icon"><Icon name="mail" size={22} /></span>
          <div>
            <h3 className="newsletter__title">{t('Stay Updated')}</h3>
            <p className="newsletter__sub">{t('Subscribe to our newsletter for latest updates and offers.')}</p>
          </div>
        </div>
        {state === 'done' ? (
          <div className="notice notice--success newsletter__done"><Icon name="circle-check" size={18} />{t("Thank you! We'll keep you posted.")}</div>
        ) : (
          <form className="newsletter__form" onSubmit={submit} noValidate>
            <label className={`control${state === 'invalid' ? ' is-invalid' : ''}`}>
              <Icon name="mail" size={16} />
              <span className="sr-only">{t('Email address')}</span>
              <input type="email" placeholder={t('Enter your email')} value={email} onChange={(e) => { setEmail(e.target.value); if (state === 'invalid') setState('idle'); }} autoComplete="email" />
            </label>
            <Button type="submit" disabled={state === 'sending'}>{state === 'sending' ? t('Subscribing…') : t('Subscribe')}</Button>
          </form>
        )}
        {state === 'invalid' && <div className="field__error" style={{ marginTop: 8 }}>{t('Please enter a valid email address.')}</div>}
        {state === 'error' && <div className="field__error" style={{ marginTop: 8 }}>{t('Something went wrong. Please try again.')}</div>}
      </div>
    </div>
  );
}
